import { AuthorizeContext } from "@/app/AuthorizeProvider";
import { useCallback, useContext, useEffect } from "react";
import useAddShowcase, { EventConfig } from "./useAddShowcase";
import { TProductInfo } from "@/typings";
import { TrackingBtnId } from "@/shared";

interface UseRequestSampleProps {
  productData?: TProductInfo;
  eventConfig?: EventConfig;
}

interface ReturnUseRequestSampleProps {
  handleFreeSample: (data?: TProductInfo, eventConfig?: EventConfig) => void;
  loading?: boolean;
  isAddedShowcase?: boolean;
}

export default function useRequestSample(
  props: UseRequestSampleProps
): ReturnUseRequestSampleProps {
  const { productData, eventConfig } = props;

  const { checkShowcaseAuthorize, isAddedShowcase, loading } = useAddShowcase({
    productData,
    eventConfig: {
      btn_id: TrackingBtnId.FreeSample,
      ...eventConfig,
    },
    addedMsg: false,
    haveAppliedMsg: false,
  });

  const authorizeCtx = useContext(AuthorizeContext);

  useEffect(() => {
    if (isAddedShowcase && productData) {
      authorizeCtx?.$skuVisible?.(true);
      authorizeCtx?.$product?.(productData);
      authorizeCtx?.$eventConfig?.(eventConfig);
    }
  }, [isAddedShowcase, productData, eventConfig, authorizeCtx]);

  const handleFreeSample = useCallback(() => {
    checkShowcaseAuthorize();
  }, [checkShowcaseAuthorize]);

  return {
    handleFreeSample,
    isAddedShowcase,
    loading,
  };
}
